import { render, staticRenderFns } from "./headerDetails.vue?vue&type=template&id=36aaee18&scoped=true"
import script from "./headerDetails.vue?vue&type=script&lang=js"
export * from "./headerDetails.vue?vue&type=script&lang=js"
import style0 from "./headerDetails.vue?vue&type=style&index=0&id=36aaee18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36aaee18",
  null
  
)

export default component.exports